/**
 * Обрабатывает пути изображений и видео:
 * - Локальные пути ('images', '/images') возвращаются как есть
 * - Для статических ресурсов ('assets', 'videos', 'media' и их варианты с '/') всегда используется PROD_URL
 * - Остальные пути в dev получают stage-домен, на проде — оригинальный путь
 */
const URL_CONFIG = {
  LOCAL_PREFIXES: ['images', '/images'] as const,
  STATIC_PREFIXES: [
    'assets',
    'videos',
    'media',
    '/assets',
    '/videos',
    '/media',
  ] as const,
  STAGE_URL: 'https://stage.pingwin.fun',
  STAGE2_URL: 'https://stage2.pingwin.fun',
  // PROD_URL: 'https://pingwincasino.com',
  ENV_DEV: 'development',
} as const;

const STAGE_HOST = new URL(URL_CONFIG.STAGE_URL).host;
const STAGE2_HOST = new URL(URL_CONFIG.STAGE2_URL).host
  
export function isDevBuild() {
  if (typeof window === 'undefined') {
    return false;
  }


  return (
    window?.location?.hostname === STAGE_HOST ||
    window?.location?.hostname === STAGE2_HOST ||
    process.env.NODE_ENV === URL_CONFIG.ENV_DEV
  );
}

export function resolveMediaPath(path: string) {
  
  if (!path) return path;

  // Локальные пути возвращаем без изменений
  if (URL_CONFIG.LOCAL_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return path;
  }

  // Проверка на статические ресурсы
  if (URL_CONFIG.STATIC_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    const baseUrl = isDevBuild() ? URL_CONFIG.STAGE_URL : '';

    return `${baseUrl}/${path.replace(/^\//, '')}`;
  }

  // Остальные случаи: dev → stage, prod → оригинальный путь
  return process.env.NODE_ENV === URL_CONFIG.ENV_DEV
    ? `${process.env.NEXT_PUBLIC_WEB_STAGE || URL_CONFIG.STAGE_URL}${path}`
    : path;
}
